import React from 'react';
import { object } from 'prop-types';
import moment from 'moment';

import { FormattedMessage } from '../../util/reactIntl';
import { H6 } from '../../components';

import css from './ListingPage.module.css';

/**
 * Mobile-only display of the listing's housesit interval.
 *
 * On desktop these dates live in the OrderPanel sidebar (BookingDatesReadOnlyForm),
 * but that panel is wrapped in ModalInMobile, which hides its content on viewports
 * <= 1023px until the "Apply to HouseSit" modal is opened. This surfaces the same
 * dates inline on mobile so they are visible without opening the modal.
 *
 * Visibility is handled by css.housesitDatesMobile (display:none at --viewportLarge)
 * so it never duplicates the desktop sidebar.
 */
const SectionHousesitDatesMaybe = props => {
  const { availabilityInterval } = props;
  const { start, end } = availabilityInterval || {};

  if (!start || !end) {
    return null;
  }

  // Explicit moment formats ("dddd" / "D MMM YYYY") render "Wednesday" / "22 Jul 2026",
  // matching the desktop breakdown regardless of the active locale.
  const startMoment = moment(start);
  const endMoment = moment(end);

  return (
    <section className={css.housesitDatesMobile}>
      <H6 as="h3" className={css.housesitDatesTitle}>
        <FormattedMessage id="BookingDatesReadOnlyForm.priceBreakdownTitle" />
      </H6>
      <hr className={css.housesitDatesDivider} />
      <div className={css.housesitDatesRow}>
        <div className={css.housesitDateColLeft}>
          <div className={css.housesitDateLabel}>
            <FormattedMessage id="OrderBreakdown.bookingStart" />
          </div>
          <div className={css.housesitDateWeekday}>{startMoment.format('dddd')}</div>
          <div className={css.housesitDateValue}>{startMoment.format('D MMM YYYY')}</div>
        </div>
        <div className={css.housesitDateColRight}>
          <div className={css.housesitDateLabel}>
            <FormattedMessage id="OrderBreakdown.bookingEnd" />
          </div>
          <div className={css.housesitDateWeekday}>{endMoment.format('dddd')}</div>
          <div className={css.housesitDateValue}>{endMoment.format('D MMM YYYY')}</div>
        </div>
      </div>
    </section>
  );
};

SectionHousesitDatesMaybe.propTypes = {
  // { start, end } ISO date strings from listing.attributes.publicData.availabilityInterval
  availabilityInterval: object,
};

export default SectionHousesitDatesMaybe;
